import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Capacitor } from '@capacitor/core';

// Vercel SpeedInsights: 웹 배포 환경에서만 로드 (네이티브 앱에서는 불필요)
// 네이티브 앱에서 서드파티 트래킹 SDK가 동작하면 Apple 앱스토어 심사에서 지적될 수 있음
const SpeedInsightsLoader = Capacitor.isNativePlatform()
  ? () => null
  : React.lazy(() =>
      import('@vercel/speed-insights/react').then(m => ({ default: m.SpeedInsights }))
    );

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <React.Suspense fallback={null}>
      <SpeedInsightsLoader />
    </React.Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
